<script>

	import TreeLeaf from './TreeLeaf.svelte';

	export let node;
	export let selectedElement;
	export let hideRoot=false;

	export let expanded = true ;
	$: selected = (selectedElement === node);

    function toggleExpand() {
		expanded = !expanded;
	}
	function toggleSelect () {
        selectedElement=node;
    }
</script>


<style>

    span.treenode {
        font-weight: bold;
        cursor: pointer;
        white-space: nowrap;
        font-size:1.2em;
    }

    span.toggleknob {
		padding: 0 0 0 1.5em;
		background: url(icons/treeclosed.png) no-repeat 50% 50%;
		background-size: .7em;
	}
	span.toggleknob.expanded {
		background-image: url(icons/treeopen.png);
	}
    span.selected {
        background-color: #d4d4d4;
    }

	ul {
        padding: 0.2em 0 0 0.5em;
        margin: 0 0 0 0.1em;
        list-style: none;
        border-left: 1px solid #888;
    }

    li {
        padding: 0.2em 0;
    }

</style>

{#if !hideRoot}
    <span class="treenode" class:selected={selected} >
        <span class ="toggleknob" class:expanded={expanded}
              on:click={()=> { toggleExpand() }} />

        <span on:click={()=> {toggleSelect();}}>{node.label} </span>
    </span>
{/if}

{#if expanded}
	<ul>
		{#each node.children as child}
			<li>
                {#if child}
                    {#if child.children}
                        <svelte:self  node={child} bind:selectedElement={selectedElement}/>
                    {:else}
                        <TreeLeaf node={child} bind:selectedElement={selectedElement}/>
                    {/if}
                {:else}
                    could not find component data
                {/if}
			</li>

		{/each}
	</ul>
{/if}